import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (FT120)
// ============================================================

export interface FT120 {
  ft120_01: string;          // 申請單號 (PK, 8 chars)
  ft120_11: string;          // 公告開始日 (date)
  ft120_12: string;          // 公告結束日 (date)
  ft120_13: string;          // 申請人員工代碼
  ft120_14: string;          // 申請部門代碼
  ft120_15: string;          // 申請日期
  ft120_16: number;          // 分類碼
  ft120_20: string;          // 附加欄位
  ft120_21: string;          // 公告主題
  ft120_22: string;          // 公告內容 (textarea)
  ft120_61: string;          // 第一層核准狀態
  ft120_62: string;          // 第一層核准人員
  ft120_63: string;          // 第一層核准日期
  ft120_64: string;          // 核准說明
  ft120_66: string;          // 第二層核准狀態
  ft120_71: string;          // 第三層核准狀態
  ft120_72: string;          // 第三層核准人員
  ft120_73: string;          // 第三層核准日期
  ft120_74: string;          // 第三層核准說明
  ft120_76: string;          // 第四層核准狀態
  ft120_92: string;          // 存檔時間
}

export interface CreateT202Request {
  ft120_11: string;
  ft120_12: string;
  ft120_13: string;
  ft120_14: string;
  ft120_15: string;
  ft120_16: number;
  ft120_20: string;
  ft120_21: string;
  ft120_22: string;
}

export interface UpdateT202Request {
  ft120_11: string;
  ft120_12: string;
  ft120_13: string;
  ft120_14: string;
  ft120_15: string;
  ft120_16: number;
  ft120_20: string;
  ft120_21: string;
  ft120_22: string;
}

export interface ListT202Response {
  data: FT120[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

const BASE = '/api/t202';

export const t202Api = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListT202Response> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get(BASE, { params });
    return res.data;
  },

  async getByID(id: string): Promise<FT120> {
    const res = await apiClient.get(`${BASE}/${encodeURIComponent(id)}`);
    return res.data;
  },

  async create(data: CreateT202Request): Promise<FT120> {
    const res = await apiClient.post(BASE, data);
    return res.data;
  },

  async update(id: string, data: UpdateT202Request): Promise<FT120> {
    const res = await apiClient.put(`${BASE}/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`${BASE}/${encodeURIComponent(id)}`);
  },

  async search(keyword: string, page = 1, size = 100): Promise<ListT202Response> {
    const res = await apiClient.get(`${BASE}/search`, { params: { keyword, page, size } });
    return res.data;
  },
};
